import { Avatar, Box, Typography, useMediaQuery } from "@mui/material";
import { Form, Formik } from "formik";
import { Fragment, useState } from "react";
import { useLocation } from "react-router-dom";
import * as Yup from "yup";
import SubmitTickIco from "../../../assets/icons/SubmitTickIco";
import { platformWhiteLogo } from "../../../utils/logo";
import SubmissionSuccessTick from "../../../assets/icons/SubmissionSuccessTickIco";
import ReferenceBackgroundImage from "../../../assets/images/ReferenceBackgroundImage.svg";
import CommonButton from "../../../component/Button";
import DropDownSelect from "../../../component/Select";
import SnackBar from "../../../component/SnackBar";
import { CandidateCoverSheetUpdateStatus } from "../../../redux/action/CoverSheet";
import { CustomDiv } from "../../chat-bot/style";
import { CoversheetUpload } from "../../common-components/CoverSheetFunction";
import { CommonGrid2 } from "../../common-components/StyledComponents";
import ResumeUploadFunction from "../../coversheet/candidate/components/ResumeUploadFunction";
import { CustomizeSpan } from "../../jobs/style";
import { Place } from "@mui/icons-material";

export default function CoverSheetCandidate() {
  const query = new URLSearchParams(useLocation().search);
  const coverId = query.get("id");
  const fullName = query.get("name") || "";
  const organization = query.get("organization");
  const orgLogoUrl = decodeURIComponent(query.get("org_logo_url") || "");
  // const orgLogoUrl =
  //   "https://dev-talentium-x.s3.amazonaws.com/talairo/logo/Karthiks_Agency_X23_logo.jpeg?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIA6HNCS6SFM7FPQLVH%2F20260216%2Fca-central-1%2Fs3%2Faws4_request&X-Amz-Date=20260216T145844Z&X-Amz-Expires=604800&X-Amz-SignedHeaders=host&X-Amz-Signature=0be29a13b3540af0074586caea9eb78bad8d4c478e6e9abb063a3946a5f50e2d";
  console.log(orgLogoUrl, "orgLogoUrl");
  const coverName = fullName.trim().split(/\s+/)[0];
  const [submittedAvailability, setSubmittedAvailability] = useState("");

  const INTERESTED = "I am available and interested";

  const [isLoading, setIsLoading] = useState({
    loading: false,
    completed: false,
  });

  const [snackbarState, setSnackbarState] = useState({
    open: false,
    message: "",
    severity: "",
  });

  const coverSheetData = {
    roleData: [
      {
        name: "I am available and interested",
      },
      {
        name: "I am not available",
      },
      { name: "I am unavailable but lets keep in touch" },
    ],
  };

  const validationSchema = Yup.object({
    availability_status: Yup.string().required("Role is required"),
  });
  const handleRemoveFile = (index, item, values, setFieldValue) => {
    const updated = values[item.titleName].filter((_, i) => i !== index);

    setFieldValue(item.titleName, updated);
  };

  const handleCloseValidation = () => {
    setSnackbarState((prev) => ({ ...prev, open: false }));
  };
  const lg = useMediaQuery("(min-width:767px)");

  const handleSubmit = async (values) => {
    setIsLoading({ loading: true, completed: false });

    try {
      setSubmittedAvailability(values.availability_status);
      const formData = new FormData();

      const payload = {
        resume_id: coverId,
        availability: values.availability_status,
      };

      formData.append("data", JSON.stringify(payload));

      if (values.resume_file?.length > 0) {
        formData.append("resume_file", values.resume_file[0]?.file);
      }

      await CandidateCoverSheetUpdateStatus(formData);

      setIsLoading({ loading: false, completed: true });
    } catch (error) {
      setIsLoading({ loading: false, completed: false });
      setSnackbarState({
        open: true,
        message: error.message || "Something went wrong",
        severity: "error",
      });
    }
  };

  return (
    <CustomDiv
      sx={{
        height: "100vh",
        width: "100%",
        backgroundImage: `url(${ReferenceBackgroundImage})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        display: "flex",
        flexDirection: "column",
      }}
      boxShadow="1px 1px 5px 3px rgb(16 24 40 / 13%)"
      padding={lg ? "2rem" : "1rem"}
    >
      <Box
        mb={lg ? 2 : 0}
        width={"100%"}
        display={"flex"}
        justifyContent={{ xs: "center", md: "center" }}
        alignItems={"center"}
        mt={lg ? "0px" : "1rem"}
      >
        <Fragment>
          {typeof orgLogoUrl === "string" ? (
            <CommonGrid2 display={"flex"} gap={"10px"} alignItems="center">
              <Avatar
                src={orgLogoUrl}
                sx={{
                  width: lg ? "40px" : "30px",
                  height: lg ? "40px" : "30px",
                }}
              />

              <Typography
                variant={lg ? "h5" : "subtitle3"}
                color="#fff"
                fontWeight={700}
              >
                {organization}
              </Typography>
            </CommonGrid2>
          ) : (
            platformWhiteLogo({ width: "150" })
          )}
        </Fragment>
      </Box>
      <Box flex={1} display="flex" justifyContent="center" alignItems="center">
        {isLoading.completed ? (
          <Box
            width="100%"
            maxWidth="800px"
            textAlign="center"
            display="flex"
            flexDirection="column"
            alignItems="center"
            justifyContent="center"
            gap={2}
          >
            {/* Green Circle Check */}
            <Box
              sx={{
                width: 56,
                height: 56,
                borderRadius: "50%",
                backgroundColor: "#12B76A",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <SubmissionSuccessTick />
            </Box>

            {/* Main Heading */}
            <Typography
              fontSize={lg ? "32px" : "18px"}
              fontWeight={700}
              color="#FFFFFF"
            >
              Submission Successful !
            </Typography>

            {/* Sub Text */}
            <Typography
              maxWidth="600px"
              fontSize={lg ? "16px" : "14px"}
              fontWeight={400}
              color="#E4E7EC"
              lineHeight={1.6}
            >
              Thank You{" "}
              <Box component={"span"} color={"#FF4DA6"} fontWeight={600}>
                {coverName}
              </Box>
              {submittedAvailability === "I am available and interested"
                ? ". We will let you know about any job openings we find through your email."
                : "  for letting us know."}
            </Typography>
          </Box>
        ) : (
          <Box width={{ xs: "100%", md: "70%" }}>
            <Typography
              sx={{
                fontSize: {
                  xs: "18px",
                  sm: "22px",
                  md: "26px",
                  lg: "32px",
                },
              }}
              fontWeight={700}
              color="#FFFFFF"
              lineHeight={1.4}
              textAlign="center"
            >
              Hi{" "}
              <Box component="span" color="#FF4DA6">
                {coverName}
              </Box>{" "}
              ! Are you open to new opportunities?
            </Typography>

            <Typography
              mt={2}
              fontSize={lg ? "16px" : "14px"}
              fontWeight={400}
              color="#E4E7EC"
              lineHeight={1.6}
              textAlign={"center"}
            >
              We have received your resume through our recruitment partner and
              wanted to check if you might be open to exploring new
              opportunities at this time.
            </Typography>

            <Formik
              initialValues={{
                availability_status: "",
                resume_file: [],
              }}
              validationSchema={validationSchema}
              onSubmit={handleSubmit}
            >
              {(form) => (
                <Form>
                  <Box
                    display="flex"
                    flexDirection="column"
                    alignItems="center"
                    width={"100%"}
                    gap={"2rem"}
                  >
                    <Box
                      display="flex"
                      flexDirection="column"
                      alignItems="center"
                      width={"100%"}
                      marginTop={lg ? "2rem" : "1rem"}
                    >
                      <Typography
                        color="white"
                        fontWeight={200}
                        variant={lg ? "body1" : "subtitle2"}
                        textAlign={"left"}
                        width={lg ? "60%" : "80%"}
                      >
                        Your Answer<span style={{ color: "red" }}>*</span>
                      </Typography>
                      <DropDownSelect
                        removeAnimation
                        sizeMedium={"-4px"}
                        title="- Select -"
                        data={coverSheetData.roleData}
                        value={form.values.availability_status}
                        error={Boolean(
                          form.touched.availability_status &&
                            form.errors.availability_status
                        )}
                        helperText={
                          form.touched.availability_status &&
                          form.errors.availability_status
                        }
                        handleChange={(event) =>
                          form.setFieldValue(
                            "availability_status",
                            event.target.value
                          )
                        }
                        customStyle={{
                          width: lg ? "60%" : "80%",
                          "& .MuiOutlinedInput-root": {
                            backgroundColor: "#FFFFFF",
                            borderRadius: "8px",
                          },
                          "& .MuiFormLabel-root.Mui-focused": {
                            display: "none",
                          },
                          "& fieldset": {
                            display: "none",
                          },
                          "& .MuiSvgIcon-root": {
                            color: "#667085",
                          },
                        }}
                      />
                    </Box>

                    {form.values.availability_status === INTERESTED && (
                      <Box textAlign="center" width={"100%"}>
                        <Typography color={"#FFFFFF"} marginBottom={1}>
                          Please Upload your Current Resume{" "}
                          <CustomizeSpan color={"#079455"}>
                            (Optional)
                          </CustomizeSpan>
                        </Typography>

                        <Fragment>
                          <CommonGrid2
                            spacing={2}
                            container
                            justifyContent="center"
                          >
                            <ResumeUploadFunction
                              handleRemoveFile={(index, item) =>
                                handleRemoveFile(
                                  index,
                                  item,
                                  form.values,
                                  form.setFieldValue
                                )
                              }
                              item={{
                                titleName: "resume_file",
                                uploadCustomSize: 12,
                              }}
                              values={form.values["resume_file"]}
                            />
                          </CommonGrid2>

                          <CoversheetUpload
                            sx={{
                              backgroundColor: "white",
                              minWidth: "25%",
                              width: {
                                xs: "80%",
                                sm: "60%",
                                md: "40%",
                                lg: "25%",
                              },
                              padding: "10px",
                              marginTop: "10px",
                              fontSize: !lg && "13px",
                              // marginBottom: "20px",
                            }}
                            values={form.values}
                            setFieldValue={form.setFieldValue}
                            item={{
                              titleName: "resume_file",
                              single_upload: true,
                            }}
                          />
                        </Fragment>
                      </Box>
                    )}

                    <Box textAlign="center" width={"100%"}>
                      <CommonButton
                        variant="contained"
                        color="white"
                        background="#7F56D9"
                        fontWeight="600"
                        padding="12px"
                        value="Submit"
                        type="submit"
                        mobileFontSize="13px"
                        sx={{
                          width: {
                            xs: "80%",
                            sm: "60%",
                            md: "40%",
                            lg: "25%",
                          },
                        }}
                        disabled={isLoading.loading}
                        loading={isLoading.loading}
                      />
                    </Box>
                  </Box>
                </Form>
              )}
            </Formik>
          </Box>
        )}
      </Box>

      <SnackBar
        snackbarState={snackbarState}
        handleCloseValidation={handleCloseValidation}
      />
    </CustomDiv>
  );
}
